import { render, staticRenderFns } from "./NewNumber.vue?vue&type=template&id=ce635568&scoped=true"
import script from "./NewNumber.vue?vue&type=script&lang=js"
export * from "./NewNumber.vue?vue&type=script&lang=js"
import style0 from "./NewNumber.vue?vue&type=style&index=0&id=ce635568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce635568",
  null
  
)

export default component.exports